export type TabType = 'general' | 'measures' | 'auscultation' | 'history';

/** Tab order of the campaign detail page — also the child route names under `campaigns/:id`. */
export const CAMPAIGN_TAB_ROUTES: readonly TabType[] = ['general', 'measures', 'auscultation', 'history'];

/**
 * Tab a campaign detail url points at, falling back to general. Router urls carry query params and
 * fragments, so those are dropped first: a link like `.../measures?measureId=12` names the measures
 * tab, not an unknown one.
 */
export function campaignTabFromUrl(url: string): TabType {
  const parts = (url.split(/[?#]/)[0] ?? url).split('/');
  const campaignIndex = parts.findIndex(part => part === 'campaigns');
  if (campaignIndex < 0) return 'general';

  // campaigns/<id>/<tab>
  const tab = parts[campaignIndex + 2];
  return CAMPAIGN_TAB_ROUTES.find(route => route === tab) ?? 'general';
}
